import { FieldPattern } from '..';

import { DayWiseSlotHoldDatesDetailInterface } from '@nw/shared/config';

import { SLOT_SELECTION_FIELD } from '../../../../constants/FieldTypeConstants';

import DependentField from '../DependentField';

interface SlotSelectionFieldTimeLapsedOptionType {
  time_value: string;
  label?: string;
  max_visibility_time: string;
  preferred_days: number[];
  match_keys: string[];
  condition?: string;
  option_type?: string;
  lead_type?: string;
  extra_dates_to_show_slot?: string[];
  slot_hold_dates?: string[];
  is_immediate_slot?: boolean;
}

class SlotSelectionField extends DependentField {
  readonly type: string = SLOT_SELECTION_FIELD;
  slotOptions: SlotSelectionFieldTimeLapsedOptionType[];
  intensiveSlotsLanguageOptions: Record<string, string[]>;
  academySlotsLanguageOptions: Record<string, string[]>;
  slotConditions: Record<string, string>;
  dayWiseSlotHoldDates: DayWiseSlotHoldDatesDetailInterface[];
  slotUIType = '';
  isDateBasedSlots: boolean;
  showAllSlotsState?: boolean;
  //TODO: Add the type for slotOptions
  constructor(slotSelectionField: any, initialValue = '') {
    super(slotSelectionField, initialValue);
    this.slotOptions = slotSelectionField.slot_options ?? [];
    this.supportingField = slotSelectionField.supporting_field ?? '';
    this.intensiveSlotsLanguageOptions =
      slotSelectionField.intensive_slots_language_options ?? {};
    this.academySlotsLanguageOptions =
      slotSelectionField.academy_slots_language_options ?? {};
    this.dayWiseSlotHoldDates =
      slotSelectionField.day_wise_slot_hold_dates ?? [];
    this.slotConditions = slotSelectionField.slotConditions ?? {};
    if (slotSelectionField.slots_ui_type) {
      this.slotUIType = slotSelectionField.slots_ui_type;
    }
    this.isDateBasedSlots = slotSelectionField.is_date_based_slots ?? false;
    this.showAllSlotsState = slotSelectionField.showAllSlotsState ?? false;
  }

  match<T>(p: FieldPattern<T>): T {
    return p.SlotSelectionField(this);
  }
}

export default SlotSelectionField;
